import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Constant
import ROUTE from '../../constants/route-constants';

// Store
import { Dispatch, RootState } from '../../store/store';

// Components
import IconGear from '../Icons/IconGear/IconGear';
import IconExit from '../Icons/IconExit/IconExit';
// import IconUser from '../Icons/IconUser/IconUser';
import UserAvatar from '../UserAvatar/UserAvatar';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { ElementSize } from '../../types/element-size';

// Types
type DropdownUserProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const DropdownUser: React.FC<DropdownUserProps> = ({ signOut, userData }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const trigger = useRef<any>(null);
  const dropdown = useRef<any>(null);

  const logOut = () => {
    signOut();
  };

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }: MouseEvent) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  return (
    <div className="c-dropdown-user relative">
      {userData !== null ? (
        <><div className='flex flex-row items-center gap-4 min-h-9'>
          <UserAvatar userFirstName={userData?.first_name} userLastName={userData?.last_name} className='bg-gradient-to-b from-primary to-burnt-coral' size={ElementSize.SM} />
          <span className='max-sm:hidden w-8 h-8 flex items-center justify-center'>
            <svg
              ref={trigger}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="block cursor-pointer fill-current text-gray-500 hover:w-8 hover:h-8 active:text-orange-500 transition-all duration-300 ease-in-out"
              width="22"
              height="22"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.410765 0.910734C0.736202 0.585297 1.26384 0.585297 1.58928 0.910734L6.00002 5.32148L10.4108 0.910734C10.7362 0.585297 11.2638 0.585297 11.5893 0.910734C11.9147 1.23617 11.9147 1.76381 11.5893 2.08924L6.58928 7.08924C6.26384 7.41468 5.7362 7.41468 5.41077 7.08924L0.410765 2.08924C0.0853277 1.76381 0.0853277 1.23617 0.410765 0.910734Z"
                fill="" />
            </svg>
          </span>
        </div><div
          ref={dropdown}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setDropdownOpen(false)}
          className={`absolute right-0 mt-4 flex w-62.5 flex-col rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark ${dropdownOpen === true ? 'block' : 'hidden'}`}
        >
          <ul className="flex flex-col gap-5 border-b border-stroke px-6 py-7.5 dark:border-strokedark">
            <li>
              <Link
                to={ROUTE.PROFILE}
                className="flex items-center gap-3.5 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base"
              >
                <IconGear />
                  Settings
              </Link>
            </li>
          </ul>
          <button className="flex items-center gap-3.5 px-6 py-4 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base" onClick={logOut}>
            <IconExit />
              Log Out
          </button>
        </div></>
      ) : (
        <SpinnerLoader className='w-9 h-9' />
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  userData: state.user.profile,
});

const mapDispatch = (dispatch: Dispatch) => ({
  signOut: dispatch.auth.signOut,
});

export default connect(mapState, mapDispatch)(DropdownUser);
